import { render, staticRenderFns } from "./AscPlotsViewerWrapper.vue?vue&type=template&id=c683ef32&"
import script from "./AscPlotsViewerWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPlotsViewerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPlotsViewerWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports